export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f242ca2d0d8a6b38ff002570746ecfb6969420288&name=fetchTypeahead!'